<template >
	<div id="app">
		<router-view/>
	</div>
</template>
<script>
import store from './store'

export default {
	name: 'App',
	mounted () {
		// initial call
		store.commit('setNavLinks', this.$e24Common.storageService.findItem('navLinks', true))
		this.$e24Common.security.getSharedLoginStatus()
		this.$nextTick(() => {
			document.title = 'California Title 24 Report Service: Energy Compliance and Calculations'
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/App.vue